import { useIntl } from "react-intl";
import ErrorPage from "../ErrorPage/ErrorPage";

const PageNotFound = () => {
  const intl = useIntl();
  return (
    <ErrorPage
      type="404"
      title={intl.formatMessage({
        id: "Error Page Title",
        defaultMessage: "Page not found",
      })}
      description={intl.formatMessage({
        id: "Error Page Description",
        defaultMessage:
          "We’re sorry, it seems we were not able to redirect you to the right page. Please click on the link below to be redirected to identity management or click on ‘Contact Us’ to reach out to our support team",
      })}
      imgUrl="/ui/images/Truman-UI-error-page.svg"
    />
  );
};

export default PageNotFound;
